/* ============
 * Actions for the patient module
 * ============
 *
 * The actions that are available on the
 * patient module.
 */
import Vue from 'vue';
import PatientProxy from '@/proxies/PatientProxy';
import message from '@/constants/_message';
import types from './mutation-types';

export const getPatients = ({ commit }, data) => {
  commit(types.FETCH_PATIENT_LIST);
  new PatientProxy().fetchPatients(data).then((response) => {
    commit(types.FETCH_PATIENT_LIST_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_PATIENT_LIST_FAIL, error);
  });
};

export const assignCareplan = ({ commit, dispatch }, data) => {
  commit(types.ASSIGN_CAREPLAN);
  new PatientProxy().assignCareplan(data).then((assignedCareplan) => {
    commit(types.ASSIGN_CAREPLAN_SUCCESS, {
      assignedCareplan
    });
    if (data.isEnrollmentCareplan) {
      dispatch('getPatients', data.filter);
    }
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.CAREPLAN_ASSIGNED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.ASSIGN_CAREPLAN_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.CAREPLAN_NOT_ASSIGNED,
      type: 'error'
    });
  });
};

export const unAssignCareplan = ({ commit, dispatch }, {data, filter}) => {
  commit(types.UN_ASSIGN_CAREPLAN);
  new PatientProxy().unAssignCareplan(data).then((unAssignedCareplan) => {
    commit(types.UN_ASSIGN_CAREPLAN_SUCCESS, {
      unAssignedCareplan
    });
    dispatch('getPatients', filter);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.CAREPLAN_UNASSIGNED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UN_ASSIGN_CAREPLAN_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.CAREPLAN_NOT_UNASSIGNED,
      type: 'error'
    });
  });
};

export const update = ({ commit }, { data, id }) => {
  commit(types.CREATE_PATIENT);
  new PatientProxy().update({ data, id }).then((response) => {
    commit(types.CREATE_PATIENT_SUCCESS, response);
    Vue.router.push({
      name: 'patientList.view',
      params: { id: response.id }
    });
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_UPDATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.CREATE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_UPDATED,
      type: 'error'
    });
  });
};

export const remove = ({ commit }, obj) => {
  commit(types.DELETE_PATIENT);
  new PatientProxy().update(obj).then((response) => {
    commit(types.DELETE_PATIENT_SUCCESS, response.id);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_DELETED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.DELETE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_DELETED,
      type: 'error'
    });
  });
};

export const getPatient = ({ commit }, id) => {
  commit(types.GET_PATIENT_EHR);
  return new Promise((resolve, reject) => {
    new PatientProxy().view(id).then((response) => {
      commit(types.GET_PATIENT_EHR_SUCCESS, response);
      resolve();
    }).catch((error) => {
      commit(types.GET_PATIENT_EHR_FAIL, error);
      reject();
    });
  });
};

export const clearPatientList = ({commit}) => {
  commit(types.CLEAR_PATIENT_LIST);
};

export default {
  assignCareplan,
  getPatients,
  update,
  remove,
  getPatient,
  unAssignCareplan,
  clearPatientList
};
